var m;(function(l){l[l.sm=640]="sm",l[l.md=768]="md",l[l.lg=1024]="lg",l[l.xl=1280]="xl",l[l["2xl"]=1536]="2xl"})(m||(m={}));export{m as Breakpoints};
